import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../content/card/card';
import useHideOnSite from '../../hooks/useLanguageFilter';

export const GetTripAdvisorJSON = ({ blok, hotel }) => {
  const { t } = useTranslation(['hotel']);

  const tripAdvisorBlockIds = ['ta_v0', 'ta_v1', 'ta_v2', 'ta_v3'];
  const tripAdvisorBlock = {
    _uid: tripAdvisorBlockIds[0],
    name: 'Tripadvisor',
    width: blok.width || 'w-full',
    blocks: [
      {
        _uid: tripAdvisorBlockIds[1],
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                level: 3,
              },
              content: [
                {
                  text: t('Tripadvisor title'),
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: t('Tripadvisor description', {
                    rating: hotel.tripadvisor.rating,
                    numberOfRatings: hotel.tripadvisor.numberOfRatings,
                  }),
                  type: 'text',
                },
              ],
            },
          ],
        },
        color: 'text-black',
        width: 'w-full',
        component: 'text',
        align_text: 'text-left',
        background_color: 'green',
      },
      {
        _uid: tripAdvisorBlockIds[2],
        link: {
          id: '',
          url: hotel.tripadvisor.url,
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: hotel.tripadvisor.url,
        },
        type: 'expanded',
        label: t('Tripadvisor link'),
        component: 'button_link',
      },
    ],
    height: 'full',
    component: 'card',
    vertical_align: 'items-start',
    background_color: 'green',
  };

  return tripAdvisorBlock;
};

const HotelTripadvisor = ({ blok, hotel }) => {
  const tripAdvisorBlock = GetTripAdvisorJSON({ blok, hotel });
  return useHideOnSite(blok.hide_on_site) ? null : (
    <Card blok={tripAdvisorBlock} />
  );
};

export default HotelTripadvisor;
